import { Component, Input } from '@angular/core';

import { Usuario } from '../../usuario';

@Component({
    selector: 'sgt-usuario-permissao-plm',
    templateUrl: './usuario-permissao-plm.component.html',
    styleUrls: ['./usuario-permissao-plm.component.less']
})
export class UsuarioPermissaoPLMComponent {
    @Input() entity: Usuario;
}
